import { useState } from "react";
import InputText from "components/components/InputText";
import { PasswordRuleChecklist } from "components/components/PasswordRuleChecklist/PasswordRuleChecklist";
import FieldValidator from "components/components/FieldValidator";
import TranslationText from "components/components/Translation/TranslationText";
import FetcherApi from "components/components/FetcherApi";
import { EyeSvg } from "components/icons/EyeSvg";

export default function CreatePasswordForSmartId({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const onPasswordChange = (e) => {
    setPassword(e.value);
    setErrors((prev) => ({ ...prev, password: undefined }));
  };
  const onRepeatPasswordChange = (e) => {
    setRepeatPassword(e.value);
    setErrors((prev) => ({ ...prev, repeatPassword: undefined }));
  };

  const validate = () => {
    let errors = {};
    if (!FieldValidator.passwordSatisfiesRequirements(password)) {
      errors.password = "add_your_data_page_pwd_rules_error";
    }
    if (password !== repeatPassword) {
      errors.repeatPassword = "add_your_data_page_pwd_not_match_error";
    }
    return errors;
  };

  const onSubmit = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setIsSubmitting(true);
    const res = await FetcherApi.put("/api/Password", { NewPassword: password, CurrentPassword: "" });
    setIsSubmitting(false);
    const result = res.response.data;
    if (!result.success) {
      setErrors({ password: result.error || "unexpected_error" });
      return;
    }
    if (onSuccess) onSuccess();
  };

  return (
    <div className="card-content password-create-block">
      <h1 className="centered"><TranslationText text="smartid_create_password_title" /></h1>
      <div className="form-row row-center">
        <div className="form-field full-width">
          <label className="form-field__label">
            <TranslationText text="smartid_create_password_enter_password_label" />
          </label>
          <div className="form-field-container">
            <InputText
              id="new-password"
              onChange={onPasswordChange}
              prop="password"
              value={password}
              type={showPassword ? "text" : "password"}
              className="form-field__input"
            />
            <button
              type="button"
              className={`form-field__card-icon togglePassword${showPassword ? " show" : ""}`}
              onClick={() => setShowPassword((v) => !v)}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                font: 'inherit'
              }}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <EyeSvg />
            </button>
          </div>
          {errors.password && (
            <div className="sublabel error-msg show">
              <span><TranslationText text={errors.password} /></span>
            </div>
          )}
        </div>
      </div>
      <div className="form-row row-center">
        <div className="form-field full-width">
          <label className="form-field__label">
            <TranslationText text="smartid_create_password_repeat_password_label" />
          </label>
          <div className="form-field-container">
            <InputText
              id="repeat-password"
              onChange={onRepeatPasswordChange}
              prop="repeatPassword"
              value={repeatPassword}
              type={showRepeatPassword ? "text" : "password"}
              className="form-field__input"
            />
            <button
              type="button"
              className={`form-field__card-icon togglePassword${showRepeatPassword ? " show" : ""}`}
              onClick={() => setShowRepeatPassword((v) => !v)}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'inherit',
                font: 'inherit'
              }}
              aria-label={showRepeatPassword ? "Hide password" : "Show password"}
            >
              <EyeSvg />
            </button>
          </div>
          {errors.repeatPassword && (
            <div className="sublabel error-msg show">
              <span><TranslationText text={errors.repeatPassword} /></span>
            </div>
          )}
        </div>
      </div>
      <div className="password-rule-checklist-wrapper">
        <div className="password-rule-checklist-instructions">
          <PasswordRuleChecklist password={password} neutralRulesDisabled={true} />
        </div>
      </div>
      <div className="row button-row row-center full-width">
        <button
          className="button button-primary"
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting || !password || !repeatPassword || Object.keys(validate()).length > 0}
        >
          <TranslationText text="create_password_page_login_continue_btn" />
        </button>
      </div>
    </div>
  );
} 